import request from 'utils/request'

export const getMCAXS471InitRequest = () =>
  request({
    url: '/MCAXS471/init',
    method: 'post',
  })
